"use strict";
import Vue from "vue";
import zapan from "@tsyl/zapan";

Vue.use(zapan);
